import Lock from '@monofront/design-system/visuals/Icons/Old/Lock';
import Support from '@monofront/design-system/visuals/Icons/Old/Support';
import Delivery from '@monofront/design-system/visuals/Illustrations/Delivery';
import { IListBox } from '@monofront/design-system/components/ListBox';
import { OurGuaranteesKeys } from '../types';

const useOurServiceGuaranteesContent: () => IListBox<OurGuaranteesKeys> =
  () => ({
    title: 'service.title',
    lines: [
      {
        icon: Lock,
        text: 'service.line_1',
      },
      {
        icon: Delivery,
        text: 'service.line_2',
      },
      {
        icon: Support,
        text: 'service.line_3',
      },
    ],
  });

export default useOurServiceGuaranteesContent;
